import {platformAPI} from "../../../api/axiosConfig";
import {MassWarningTemplate} from "../typedefs";
import {useQuery} from "react-query";

async function fetchMassWarningTemplate(id: string | undefined) {
    if (!id){
        return null
    }
    const res = await platformAPI.get<MassWarningTemplate>(`api/siren/templates/${id}`)

    return res.data

}


export function useGetMassWarningTemplate(id: string | undefined) {

    const {data, isLoading, error, refetch} = useQuery(
        ["mass-warning-template", id],
        () => fetchMassWarningTemplate(id),
        {
            enabled: !!id,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        data,
        isLoading,
        error,
        refetch
    }


}